import React, {useState, useEffect} from 'react';
import {Container} from 'react-bootstrap';
import moment from 'moment';
import {FormattedMessage, useIntl} from 'react-intl';
import '../styles/company.css';
import '../styles/typography.css';
import {CustomButton} from '../components/CustomButton';
import {ReactComponent as CloseIcon} from '../images/close.svg';
import NewInfoRow from '../components/NewInfoRow';
import webClient from '../api/webClient';
import {toimintaEnum} from '../static/toimintaEnum';
import * as R from 'ramda';

const NewCompany = ({companyId, closeCompanyInfo}) => {
  const intl = useIntl();
  const [company, setCompany] = useState(null);

  const companyChangedInfoLink = intl.formatMessage({id: 'company-changed_info_link'});
  const contactEmail = intl.formatMessage({id: 'contact-email'});

  // componentDidMount equivalent
  useEffect(() => {
    fetchCompany(companyId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // empty dependency → runs once after mount

  // componentDidUpdate equivalent
  useEffect(() => {
    if (companyId) {
      fetchCompany(companyId);
    }
  }, [companyId]); // runs every time companyId changes

  const fetchCompany = async id => {
    try {
      await webClient.post('Yrityksenperustiedot/Hae', {yritysid: id}).then(response => {
        setCompany(response.data);
      });
    } catch (error) {
      /* eslint-disable no-console */
      console.error('Failed to fetch company', error);
    }
  };

  if (!company) return null;

  const renderForceOfLaw = value => {
    if(value === true) {
        return intl.formatMessage({
          id: 'sanctions-force_of_law_true'
        }).toLowerCase();
      }
      else {
        return intl.formatMessage({
          id: 'sanctions-force_of_law_false'
        }).toLowerCase();
      }
  };

  const handlePositions = (asemat, locale) => {
    const localizedPositions = asemat.map(asema => (locale === 'fi' ? asema.AsemaFi : asema.AsemaSv));
    return localizedPositions.join(', ');
  };

  const renderBusinessType = (businessType, locale) => {
    const type = R.find(R.propEq(businessType, 'value'))(toimintaEnum);
    return type[`label_${locale}`];
  };

  const sanctionDetailArray = company.Sanktiot.All.flatMap(item => [
    `${intl.locale === 'fi' ? item.TypeLabelFi ?? '' : item.TypeLabelSv ?? ''}`,
    `${intl.formatMessage({id: 'sanctions-docket'})} ${item.DiaariNumber ?? ''}`,
    `${intl.formatMessage({id: 'sanctions-verdict_date_new'})} ${moment(item.DecisionDate).format('DD.MM.YYYY')}`,
    `${intl.formatMessage({id: 'sanctions-force_of_law'})} ${item.Legal !== null ? renderForceOfLaw(item.Legal) : item.Legality}`,
    ''
  ]);

  const officesDetailArray = company.Toimipaikat.flatMap(item => [
    `${item.Katuosoite}, ${item.Postinumero} ${item.Postitoimipaikka}`
  ]);

  const businessTypeArray = company.Toimialat.flatMap(item => [
    `${renderBusinessType(item, intl.locale)}`
  ]);

  const responsiblePersonsArray = company.Vastuuhenkilot.flatMap(item => [
    `${item.Nimi}, ${handlePositions(item.Asemat, intl.locale)}`
  ]);

  return (
    <>
      {/* Overlay that covers the background when modal is open */}
      <div className="overlay d-none d-md-block visible"></div>

      <section
        className="company-info-container-wrapper"
        style={{backgroundColor: '#EAECE2', zIndex: 999}}
      >
        <Container className="company-info-container_rows-lvv">
          <CustomButton className="button close" autoFocus onClick={closeCompanyInfo}>
            <CloseIcon />
            <FormattedMessage id="company-close_info" defaultMessage="Sulje lisätiedot" />
          </CustomButton>
          <h1 className="h1-bold">{company.Toiminimi}</h1>
          <NewInfoRow
            labelId="company-company_aux_name"
            arvo={company.Aputoiminimi}
          />
          <NewInfoRow
            labelId="company-company_businessID"
            arvo={company.YTunnus}
          />
          <NewInfoRow
            labelId="company-registry_date"
            arvo={moment(company.RekisterointiPvm).format('DD.MM.YYYY')}
          />
          <NewInfoRow labelId="company-offices" arvo={officesDetailArray} />
          <NewInfoRow labelId="company-business_type2" arvo={businessTypeArray} />
          <NewInfoRow labelId="company_responsible_persons" arvo={responsiblePersonsArray} />
          <NewInfoRow labelId="sanctions-title" arvo={sanctionDetailArray} />
        </Container>
        <div className="email-address-new">
          <p className="body-lg-bold">
            <FormattedMessage id="company-contact-new" defaultMessage="Onko tiedoissa virhe?" />
          </p>
          <p style={{marginBottom: '0px'}}>
            <FormattedMessage id="company-contact-email" defaultMessage="Ota yhteyttä: " />
            <a
              href={`mailto:${contactEmail}`}
              className="link-sm"
              style={{color: 'var(--colors-tummansininen, #00008e)'}}
            >
              {contactEmail}
            </a>
          </p>
          <FormattedMessage
            id="company-changed_info"
            defaultMessage="Muuttuneet tiedot voit ilmoittaa "
          />
          <a
            style={{textDecoration: 'underline'}}
            href={companyChangedInfoLink}
          >
            <FormattedMessage
              id="company-changed_info_2"
              defaultMessage="asiointipalvelussa"
            />
          </a>.
          {/* <p>
            <a href="" className="link-sm" style={{color: 'var(--colors-tummansininen, #00008e)'}}>
              <FormattedMessage id="company-change-form-link" />
            </a>
            <FormattedMessage id="company-change-form-end" />
          </p> */}
        </div>
      </section>
    </>
  );
};

export default NewCompany;
